import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ModelProvider } from './contexts/ModelContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Home from './components/Home';
import SynthesisOptions from './components/SynthesisOptions';
import Auth from './components/Auth';
import Project from './components/Project';

function AppRoutes() {
  const { session, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!session) {
    return <Auth />;
  }

  return (
    <ModelProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/synthesis" element={<SynthesisOptions />} />
          <Route path="/project/:id" element={<Project />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ModelProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
